import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetCommentsParams,
    GetCommentsResponse,
    GetInvoiceCommentsResponse,
} from './types/comments'

type ApiGetCommentsResponse = Promise<AxiosResponse<GetCommentsResponse>>
type ApiGetInvoiceCommentsResponse = Promise<AxiosResponse<GetInvoiceCommentsResponse>>

export function getList(params: GetCommentsParams): ApiGetCommentsResponse {
    return http.get('/notification/api/wait-list', { params })
}

export function getInvoiceComments(number: string): ApiGetInvoiceCommentsResponse {
    return http.get(`/notification/api/wait-list/${number}`)
}

export default {
    getList,
    getInvoiceComments,
}
